/*
 * © 2017 Stratio Big Data Inc., Sucursal en España.
 *
 * This software is licensed under the Apache License, Version 2.0.
 * This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the terms of the License for more details.
 *
 * SPDX-License-Identifier: Apache-2.0.
 */
export { EGEO_DEMO_MODULES } from './barrels';
export { EGEO_DEMO_MENU, EgeoDemoMenu } from './demos.routes';
export { EgeoDemoModule } from './egeo-demo.module';

export { StAlertsDemoModule } from './st-alert-demo/st-alerts-demo.module';
export { StBreadcrumbsDemoModule } from './st-breadcrumbs-demo/st-breadcrumbs-demo.module';
export { StBubbleDemoModule } from './st-bubble-demo/st-bubble-demo.module';

export { StButtonDemoModule } from './st-button-demo/st-button-demo.module';
export { StColorPickerDemoModule } from './st-color-picker-demo/st-color-picker-demo.module';
export { StCheckboxDemoModule } from './st-checkbox-demo/st-checkbox-demo.module';
export { StDropdownMenuDemoModule } from './st-dropdown-menu-demo/st-dropdown-menu-demo.module';
export { StFilterSelectorDemoModule } from './st-filter-selector-demo/st-filter-selector-demo.module';
export { StFormDemoModule } from './st-form-demo/st-form-demo.module';
export { StFormListDemoModule } from './st-form-list-demo/st-form-list-demo.module';
export { StFullscreenLayoutDemoModule } from './st-fullscreen-layout-demo/st-fullscreen-layout-demo.module';
export { StHeaderDemoModule } from './st-header-demo/st-header-demo.module';
export { StInfoBoxDemoModule } from './st-info-box-demo/st-info-box-demo.module';
export { StInputDemoModule } from './st-input-demo/st-input-demo.module';
export { StLabelDemoModule } from './st-label-demo/index';
export { StMenuDemoModule } from './st-menu-demo/st-menu-demo.module';
export { StModalDemoModule } from './st-modal-demo/st-modal-demo.module';
export { StPaginationDemoModule } from './st-pagination-demo/st-pagination-demo.module';
export { StPopOverDemoModule } from './st-pop-over-demo/st-pop-over-demo.module';
export { StProgressBarDemoModule } from './st-progress-bar-demo/st-progress-bar-demo.module';
export { StRadioDemoModule } from './st-radio-demo/st-radio-demo.module';
export { StSearchDemoModule } from './st-search-demo/st-search-demo.module';
export { StRadioMenuDemoModule } from './st-radio-menu-demo/st-radio-menu-demo.module';
export { StSelectDemoModule } from './st-select-demo/select-demo.module';
export { StSpinnerDemoModule } from './st-spinner-demo/st-spinner-demo.module';
export { StSwitchDemoModule } from './st-switch-demo/st-switch-demo.module';
export { StTableDemoModule } from './st-table-demo/st-table-demo.module';
export { StDynamicTableDemoModule } from './st-dynamic-table-demo/st-dynamic-table-demo.module';
export { StTagInputDemoModule } from './st-tag-input-demo/st-tag-input-demo.module';
export { StTextareaDemoModule } from './st-textarea-demo/st-textarea-demo.module';
export { StToggleButtonsDemoModule } from './st-toggle-buttons-demo/st-toggle-buttons-demo.module';
export { StTooltipDemoModule } from './st-tooltip-demo/st-tooltip-demo.module';
export { StTwoListSelectionDemoModule } from './st-two-list-selection-demo/st-two-list-selection-demo.module';
export { StVerticalTabsDemoModule } from './st-vertical-tabs-demo/st-vertical-tabs-demo.module';
